module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/MobileHeroVideo-7df98028e31beab523a27b30ebe9c6a2.mp4";